<template>
  <div class="goMemberTopic-page">
    <img src="https://dazengzhang-xingmahui.oss-cn-beijing.aliyuncs.com/xmh-content/2023/04/19/1b21863d8ba5494d91707a538644cb7d.png" alt="简介图片">
    <img src="https://dazengzhang-xingmahui.oss-cn-beijing.aliyuncs.com/xmh-content/2023/04/19/5779673b8fde4c8fa2c527d56e19d913.png" alt="简介图片">
    <img src="https://dazengzhang-xingmahui.oss-cn-beijing.aliyuncs.com/xmh-content/2023/04/19/6827183ffd204e7aa501b8f30007d6a0.png" alt="简介图片">
    <p class="end">END</p>
    <a class="footer" href="https://sensors.feihe.com/t/exa">前往会员中心</a>
  </div>
</template>
<script>
export default {
  name: 'goMemberTopic',
  data() {
    return {
    };
  },
  // 监控data中的数据变化
  watch: {},
  methods: {
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    sensors.track("salemng_online_pageview", {});
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
};
</script>
<style lang="less" scoped>
.goMemberTopic-page {
  padding: 365px 0 54px;
  background: url(https://dazengzhang-xingmahui.oss-cn-beijing.aliyuncs.com/xmh-content/2023/04/19/868f1aa2c1a9412f84a78d01dc50c009.png), linear-gradient(180deg, rgba(17, 16, 16, 0) 0%, #111010 10%);;
  background-size: 100% auto;
  background-repeat: no-repeat;

  img {
    margin: 0 12px 8px;
    width: calc(100% - 24px);
    height: auto;
    display: block;
  }
  .end {
    line-height: 20px;
    color: rgba(225, 177, 128, 0.4);
    font-weight: 400;
    font-size: 14px;
    margin: 16px 0 24px;
    text-align: center;
  }
  .footer{
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    padding-bottom: 10px;
    display: block;
    width: 100%;
    font-weight: 600;
    font-size: 18px;
    line-height: 54px;
    text-align: center;
    color: #3B3534;
    background: linear-gradient(93.14deg, #F4EEDB 0%, #DFAC79 100%);
    box-shadow: inset 0px 1px 0px #F4EDDA;
  }
}
</style>
